export default function exhaustiveMatchingGuard(_: never): never {
  throw new Error('Failed exhaustive matching guard')
}
